interface Action {
    payload: any,
    type: string,
    apiError?: string,
    field: string,
    value?: any,
    validate: boolean
}


const errors: {
    [key: string]: string
} = {
    email: "Please add a valid email address.",
    password: "Please add a password.",
    validEmail: "Please add a valid email address."
};

//make api errors more user friendly
Object.assign(errors, {
    "400_1": errors["password"],
    "400_2": errors["email"],
    "400_3": "We cannot find an account with that email address.",
    "400_19": "Your password is incorrect.",
});

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,50}$/;

export default (data: any, action: Action) => {
    const newForm = data;
    const prop = newForm[action.field];
    if (prop) {
        if (!prop.added && (action.value || (!action.value && action.validate))) {
            prop.added = true
        }

        if (!prop.dirty && action.validate) {
            prop.dirty = true;
        }

        if (action.field === 'email') {
            prop.error = !emailPattern.test(action.value) ? errors['validEmail'] : null;
        }else {
            prop.error = (prop.added && !action.value && prop.required) ? errors[action.field] : null;
        }

        prop.error = action.apiError ? errors[action.apiError] : prop.error;
        prop.value = action.value;
    }
    const vals = Object.values(newForm).filter((f: any) => f.required);
    const valid = vals.filter((f: any) => f.added && f.value && !f.error);
    return {
        changed: true,
        valid: valid.length === vals.length,
        data: newForm,
    };
};
